import React from 'react';
import { useCMS } from '../../context/CMSContext';

const DEFAULT_FLEET_IMAGES = [
  'https://images.unsplash.com/photo-1774020131405-4372b8d0a329?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1762060853805-ac5a37f5de6c?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1700718008794-3db41f8d6c16?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1605705658744-45f0fe8f9663?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1700423287752-8cf29a6573e4?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1766561994067-dbd575e1cff2?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1700616270841-078da5600853?crop=entropy&cs=srgb&fm=jpg&q=85',
  'https://images.unsplash.com/photo-1759671934974-a4928e049dec?crop=entropy&cs=srgb&fm=jpg&q=85'
];

export const FleetSection = () => {
  const cms = useCMS();
  const fleet = cms?.fleet || [];

  return (
    <section id="fleet" className="py-24 bg-white dark:bg-[#0B0F19]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-2 bg-amber-500/10 text-amber-600 dark:text-amber-500 rounded-full text-sm font-bold mb-4">OUR FLEET</span>
          <h2 className="font-outfit text-4xl font-black text-slate-900 dark:text-white mb-4">Vehicles for Every Need</h2>
          <p className="text-lg text-slate-700 dark:text-slate-400 max-w-2xl mx-auto">From small pickups to 30ft containers — we have the right vehicle for your cargo</p>
        </div>
        <div className="grid md:grid-cols-4 gap-6">
          {fleet.map((v, i) => (
            <div key={v.name || i} className="bg-slate-50 dark:bg-slate-900/30 rounded-xl overflow-hidden border border-slate-200 dark:border-white/5 hover:border-amber-500 hover:shadow-lg transition-all duration-300 group">
              <div className="w-full h-40 overflow-hidden">
                <img src={v.image_url || DEFAULT_FLEET_IMAGES[i % DEFAULT_FLEET_IMAGES.length]} alt={v.name} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300" loading="lazy" />
              </div>
              <div className="p-4">
                <h3 className="font-outfit text-lg font-bold text-slate-900 dark:text-white mb-1">{v.name}</h3>
                <p className="text-2xl font-black text-amber-500 mb-1">{v.capacity}</p>
                <p className="text-sm text-slate-600 dark:text-slate-400">{v.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
